import homeRoute from "./Home/index.route";
import creatememorialsRoute from "./CreateMemorials/index.route";
import Theme02 from "./Theme02/index.route";
import biographiesPage from "./Biographies/index.route";
import userDashboardPage from "./UserDashboard/index.route";
import editProfilePage from "./EditProfile/index.route";
import searchBiographyPage from "./SearchBiography/index.route";
import savedBiographyPage from "./SavedBiography/index.route";
import searchByLocation from "./SearchByLocation/index.route";
import myBiographies from "./MyBiographies/index.route";
import privacyPolicy from "./PrivacyPolicy/index.route";
import terms from "./Terms/index.route";
import profile from "./Profile/index.route";
import notification from "./Notification/index.route";
import faq from "./Faq/index.route";
import choosePlan from "./ChoosePlan/index.route";
import LayoutThree from "./LayoutThree/index.route";
import LayoutFour from "./LayoutFour/index.route";
import Payment from "./Payment/index.route";
import pendingComments from "./PendingComments/index.route";

export default function route() {
  return [
    ...homeRoute(),
    ...creatememorialsRoute(),
    ...Theme02(),
    // ...Theme04(),
    ...biographiesPage(),
    ...userDashboardPage(),
    ...editProfilePage(),
    ...searchBiographyPage(),
    ...searchByLocation(),
    ...myBiographies(),
    ...savedBiographyPage(),
    ...privacyPolicy(),
    ...terms(),
    ...profile(),
    ...notification(),
    ...faq(),
    ...choosePlan(),
    ...LayoutThree(),
    ...LayoutFour(),
    ...Payment(),
    ...pendingComments(),
  ];
}
